import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import SEO from '../components/SEO'

export default function NotFoundPage() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <SEO title="Page Not Found" description="This page doesn't exist on Verse." noindex />
      <Navbar />
      <div style={{ textAlign: 'center', padding: '120px 24px' }}>
        <div style={{ fontSize: '6rem', fontWeight: 800, color: 'var(--primary)', lineHeight: 1 }}>404</div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--text)', margin: '16px 0 8px' }}>
          Page not found
        </h1>
        <p style={{ color: 'var(--text-faint)', marginBottom: '32px' }}>
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <Link to="/" className="btn btn-primary">Back to home</Link>
      </div>
    </div>
  )
}
